import { Component, OnInit, Renderer2, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ErrorResponse, AWSCognitoErrorResponse } from '../models/error.model';

@Component({
  selector: 'online-app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {

  constructor(private authService: AuthService, private fb: FormBuilder, private router: Router, private renderer: Renderer2) {
    this.renderer.addClass(document.body, 'login-screen');
  }

  forgotPasswordFormGroup: FormGroup;
  isFormSubmitted = false;
  forgotPasswordEventFired = false;
  loginIdApiError = '';

  ngOnInit() {
    this.forgotPasswordFormGroup = this.fb.group({
      loginId: ['', Validators.required]
    });
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'login-screen');
  }

  forgotPassword() {

    this.isFormSubmitted = true;

    if (this.forgotPasswordFormGroup.valid) {
      const username = this.forgotPasswordFormGroup.get('loginId').value;
      this.authService.forgotPassword(username)
        .subscribe(response => {
          //console.log(response);
          this.forgotPasswordEventFired = true;
        }, (errorResponse: AWSCognitoErrorResponse) => {

          if (errorResponse.code === 'UserNotFoundException') {
            this.loginIdApiError = 'Invalid login id';
            this.forgotPasswordFormGroup.get('loginId').setErrors({ apiValidationError: true });
          } else {
            this.loginIdApiError = errorResponse.message;
            this.forgotPasswordFormGroup.get('loginId').setErrors({ apiValidationError: true });
          }
          console.error(errorResponse);
        });

    }
  }

  cancelForgotPassword() {
    this.router.navigate(['/login']);
  }

  //show border when tab on link for accessibility
  linkTabAccessibility(event): void {
    event.style.outline = "1px solid black";
  }

  linkBlurAccessibility(event): void {
    event.style.outline = "";
  }

  errorPasswordAccessibility(): string {
    if (this.isFormSubmitted &&
      this.forgotPasswordFormGroup.get('loginId').errors &&
      this.forgotPasswordFormGroup.get('loginId').errors.required) {
      return "requiredStudentNumber";
    } else if (this.isFormSubmitted &&
      this.forgotPasswordFormGroup.get('loginId').errors &&
      this.forgotPasswordFormGroup.get('loginId').errors.apiValidationError) {
      return "apiErrorStudentNumber";
    } else {
      return "";
    }
  }
}
